<template>
  <!-- Début de l'application Vue -->
  <v-app>
    <!-- Composant Menu -->
    <Menu app v-if="hideOrShowMenu"></Menu>
    <Menu_association v-if="hideOrShowMenuAssociation" app></Menu_association>
    <!-- Menu de la nouvelle page d'accueil -->
    <MenuNew v-if="hideOrShowNewMenu"></MenuNew>
    <!-- Contenu principal -->
    <v-content app id="menu-margin" class="bg-white">
      <!-- Affichage du composant correspondant à la route actuelle -->
      <router-view></router-view>
    </v-content>
    <!-- Composant Footer -->
    <Footer v-if="hideOrShowMenu"></Footer>
    <!-- Footer de la nouvelle page d'accueil -->
    <FooterNew v-if="hideOrShowNewMenu"></FooterNew>
  </v-app>
</template>

<script>
// Importation des composants Menu et Footer
import Menu from './components/Menu';
import Menu_association from '@/components/Menu_association.vue';
import Footer from './components/footer';
import MenuNew from './components/NewMenu.vue';
import FooterNew from './components/NewFooter.vue';
// Importation du store Vuex

export default {
  name: 'App',
  components: {
    Menu,
    Menu_association,
    Footer,
    MenuNew,
    FooterNew
  },
  data() {
    return {
      hideOrShowMenu: true,
      hideOrShowMenuAssociation: false,
      hideOrShowNewMenu: false
    };
  },
  methods: {
    hideOrShow() {
      const currentUrlResetPassword = this.$router.currentRoute.name;
      if (currentUrlResetPassword === 'new_home') {
        this.hideOrShowMenu = false;
        this.hideOrShowMenuAssociation = false;
        this.hideOrShowNewMenu = true;
        this.setContentMargin(false);
      } else if (currentUrlResetPassword === 'app_download' || currentUrlResetPassword === 'page_neutre') {
        this.hideOrShowMenu = false;
        this.hideOrShowMenuAssociation = false;
        this.hideOrShowNewMenu = false;
        this.setContentMargin(false);
      } else if (
        currentUrlResetPassword === 'password_recovery' ||
        currentUrlResetPassword === 'ResetPassword' ||
        currentUrlResetPassword === 'activation' ||
        currentUrlResetPassword === 'aywa_subscription' || currentUrlResetPassword === 'aywapayment' || currentUrlResetPassword === 'tukki_subscription' || currentUrlResetPassword === 'tukkipayment' || currentUrlResetPassword === 'dem_subscription'
      ) {
        this.hideOrShowMenu = false;
        this.hideOrShowMenuAssociation = true;
        this.hideOrShowNewMenu = false;
        this.setContentMargin(false);
      } else {
        this.hideOrShowMenu = true;
        this.hideOrShowMenuAssociation = false;
        this.hideOrShowNewMenu = false;
        this.setContentMargin(true);
      }
    },
    setContentMargin(hasMargin) {
      const el = document.getElementById('menu-margin');
      if (!el) return;
      if (hasMargin) {
        el.classList.add('margin-top');
      } else {
        el.classList.remove('margin-top');
      }
    },
    initBrevo() {
      const excluded = ['/aywa', '/dem', '/tukki']
      const path = this.$route.path
      const shouldExclude = excluded.some(p => path.startsWith(p))
      if (shouldExclude || window.BrevoConversations) return
      if (window.matchMedia('(max-width: 768px)').matches) return
      window.BrevoConversationsID = '67e2c33df530b45d4407fa88'
      window.BrevoConversations = window.BrevoConversations || function() {
        (window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments)
      }
      const s = document.createElement('script')
      s.async = true
      s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js'
      document.head.appendChild(s)
    }
  },
  watch: {
    $route() {
      this.hideOrShow();
      this.initBrevo();
    }
  },
  created() {
    this.hideOrShow();
    this.initBrevo();

    // Vérification et correction de la locale
    const storedLocale = sessionStorage.getItem('locale');
    if (!storedLocale || (storedLocale !== 'FR' && storedLocale !== 'EN')) {
      // Si pas de locale ou locale invalide, forcer FR par défaut
      this.$i18n.locale = 'FR';
      sessionStorage.setItem('locale', 'FR');
    } else {
      // Utiliser la locale stockée
      this.$i18n.locale = storedLocale;
    }

    // Récupération du nom de la route actuelle
    //     const currentUrl = this.$router.currentRoute.name
    //     // Vérification si le code_partenaire est différent de 'ASS381' et si son type n'est pas 'undefined'
    //    if(store.state.user.code_partenaire != 'ASS381' && typeof store.state.user.code_partenaire !== 'undefined'){
    //         //Si la route actuelle est "dashboard", ne rien faire
    //         if (currentUrl == "dashboard"){
    //         //Si la route actuelle est "Home", afficher un message dans la console
    //         } else if(currentUrl == 'Home'){
    //             //console.log('Page accueil')
    //         ///Si la route actuelle n'est ni "dashboard" ni "Home", rediriger vers la page d'accueil
    //         } else {
    //             this.$router.push({name: currentUrl}));
    //         }
    //     const currentUrl = this.$router.currentRoute.name
    //     // Vérification si le code_partenaire est différent de 'ASS381' et si son type n'est pas 'undefined'
    //    if(store.state.user.code_partenaire != 'ASS381' && typeof store.state.user.code_partenaire !== 'undefined'){
    //         //Si la route actuelle est "dashboard", ne rien faire
    //         if (currentUrl == "dashboard"){
    //         //Si la route actuelle est "Home", afficher un message dans la console
    //         } else if(currentUrl == 'Home'){
    //             //console.log('Page accueil')
    //         ///Si la route actuelle n'est ni "dashboard" ni "Home", rediriger vers la page d'accueil
    //         } else {
    //             this.$router.push({name: currentUrl}));
    //         }

    //     }
    //     }
  }
};
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 4% !important;
}
</style>
